import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';
import Img from 'gatsby-image';

import BlockContent from '../pages/block-content';
import ReactPlayer from 'react-player';
import { slugify, rawContentToPlainText, decodeSanityAssetRef } from '../utils/utils';
import ImageCarousel from '../components/image-carousel';
import '../styles/story.scss';
import ImageOrVideo from '../components/image-or-video';
import {Link} from "gatsby";
import BodyText from '../components/woolwich-portable-text';
import { imageUrlFor } from '../lib/image-url';

export const query = graphql`
  query StoryTemplateQuery($id: String!) {
    site: sanitySiteSettings(_id: {regex: "/(drafts.|)siteSettings/"}) {
      title
      description
    }
    story: sanityStory(id: {eq: $id}) {
      title
      primaryImage {
        alt
        asset {
          id
          fluid(maxWidth: 1200) {
            ...GatsbySanityImageFluid
          }
        }
        attribution
      }
      hireThisSpaceVenue{
        title
      }
      _rawContent
      historySections{
        asset{
          ... on SanityImage {
             asset {
              fluid(maxWidth: 900) {
                ...GatsbySanityImageFluid
              }
            }
          }
          ... on SanityExtendedUrl {
            url
          }
        }
        _rawContent
        subtitle
        dateText
        caption
        attribution
      }
    }
    
    history: sanityHistoryOfTheArsenal {
      title
    }
  }
  `;

const StoryTemplate =  ({ location, data }) => {
  return (
    <Layout pageTitle={data.story.title} pageTitleColour={'khaki-green'} breadcrumb={[
      {
        title: data.history.title,
        link: `/woolwich-stories`
      }
    ]}>
      <SEO
        location={location}
        title={`${data.story.title} | ${data.site.title}`}
        description={data.story._rawContent !== null ? rawContentToPlainText(data.story._rawContent).substring(0, 120) + '...' : null}
        imageAsset={{ url: imageUrlFor(data.story.primaryImage.asset.id).url() }}
      />

      {/* Carousel */}
      <div className='image-carousel-harness'>
        <ImageCarousel images={[data.story.primaryImage]}/>
      </div>

      <div className='strip'>
        <div className='strip__middle pad-sides'>
          <div className='story__intro limit-width'>
            <BodyText
              blocks={data.story._rawContent}
            />
          </div>
        </div>
        <div className='strip__middle pad-sides'>
          {
            data.story.hireThisSpaceVenue &&
            <Link className='button story__button' to={'/venues/' + slugify(data.story.hireThisSpaceVenue.title)}>Hire This Space ↗</Link>
          }
          {
            data.story.historySections.map((item, idx) => {
              return (
                <div key={idx} className='story-item limit-width'>
                  {
                    item.dateText &&
                    <div className='story-item__date'>{item.dateText}</div>
                  }
                  <div className='story-item__title'>{item.subtitle}</div>
                  <BodyText
                    blocks={item._rawContent}
                  />
                  {
                    item.asset.length > 0 &&
                    <ImageOrVideo asset={item.asset} caption={item.caption} attribution={item.attribution} controls={true} />
                  }
                </div>
              );
            })
          }
        </div>
      </div>
    </Layout>
  );
}

export default StoryTemplate;
